<!-- 底部信息 -->
<template>
  <div class="footer">
    <div v-if="$store.state.currentTab === 'home'"></div>
    <div v-else class="line"></div>
    <div class="parents" v-if="$store.state.currentTab === 'parents'">
      <p>客服电话：010-82609308&nbsp;&nbsp;&nbsp;&nbsp;·&nbsp;&nbsp;&nbsp;&nbsp;客服传真：010-82609308&nbsp;&nbsp;&nbsp;&nbsp;·&nbsp;&nbsp;&nbsp;&nbsp;家长监护</p>
      <img src="https://cdn.welove520.com/static/res/vue/playbay/safe_notify.png">
    </div>
    <div v-else class="foot_link">
      <router-link to="/about/introduce">关于发现角</router-link>   ·
      <router-link to="/about/contact">联系我们</router-link>   ·
      <router-link to="/parents/guard">家长监护</router-link>   ·
      <router-link to="/protocol">法律声明</router-link>
    </div>

    <p>健康游戏忠告：抵制不良游戏，拒绝盗版游戏，注意自我保护，谨防上当受骗，适度游戏益脑，沉迷游戏伤身，合理安排时间，享受健康生活</p>
    <p>网络文化经营许可证：<span @click="certificate">京网文（2016）4107-519号</span>&nbsp;&nbsp;&nbsp;&nbsp;<span @click="miibeian">京ICP备12011312号-2</span>&nbsp;&nbsp;&nbsp;&nbsp;北京发现角科技有限公司</p>
    <p>地址：北京市海淀区善缘街1号5层1-523&nbsp;&nbsp;&nbsp;&nbsp;Email：welove@welove-inc.com&nbsp;&nbsp;&nbsp;&nbsp;电话：010-82609308</p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    /**
     * 经营许可证
     */
    certificate: function() {
      this.$router.push({
        name: "Certificate"
      })
    },

    /**
     * 工信部
     */
    miibeian: function() {
      window.location.href = "https://beian.miit.gov.cn/#/Integrated/index";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  margin-bottom: 40px;
}

.line {
  padding-top: 50px;
  width: 100%;
  border-bottom: 1px solid #979797;
}

.parents {
  margin-top: 40px;
}

.parents > img {
  width: 400px;
  margin-top: 25px;
  margin-bottom: 20px;
}

.foot_link {
  display: flex;
  flex-flow: row nowrap;
  margin-top: 45px;
  margin-bottom: 15px;
}

.foot_link > a {
  font-size: 14px;
  padding: 0 15px;
  display: inline-block;
}

a:-webkit-any-link {
  color: #818181;
  text-decoration: none;
}

.footer p {
  font-size: 12px;
  color: #88898e;
  text-align: center;
  margin: 5px;
}

span {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue